import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import PageStandard from "../../components/PageStandard";
import { valueOrDefault } from "../../utils";
import List from "./components/List";
import PropTypes from "prop-types";
import { listUnitsOfMeasure, listUnitsOfMeasureReset } from "../../actions";
import { filterUnitsOfMeasureByType } from "../../utils/adapters";
import LandUnitsOfMeasureEditModal from "./components/Modal";

export const WfpManagerLandUnitsOfMeasureView = ({
  isFetching,
  errorMessage,
  landUnitsOfMeasure,
  page,
  count,
  listUnitsOfMeasure,
  listUnitsOfMeasureReset,
}) => {
  const { t } = useTranslation();
  const [modalOptions, setModalOptions] = useState({isOpen: false, id: undefined, type: undefined});

  useEffect(() => {
    listUnitsOfMeasure();
    return () => {
      listUnitsOfMeasureReset();
    };
  }, []);

  return (
    <PageStandard
      title={t("configuration.item.landUnitsOfMeasure")}
    >
      <List
        {...{
          isFetching,
          errorMessage,
          landUnitsOfMeasure,
          page,
          count,
          setModalOptions,
        }}
      />
      <LandUnitsOfMeasureEditModal
        modalOptions={modalOptions}
        setModalOptions={setModalOptions}
      />
    </PageStandard>
  );
};

WfpManagerLandUnitsOfMeasureView.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  landUnitsOfMeasure: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  listUnitsOfMeasure: PropTypes.func.isRequired,
  listUnitsOfMeasureReset: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  const data = filterUnitsOfMeasureByType(state, "LAND");
  return {
    landUnitsOfMeasure: data,
    isFetching: state.listUnitsOfMeasure.isFetching,
    errorMessage: state.listUnitsOfMeasure.errorMessage,
    page: 1,
    count: valueOrDefault(data.length, 0),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    listUnitsOfMeasure: () => dispatch(listUnitsOfMeasure()),
    listUnitsOfMeasureReset: () => dispatch(listUnitsOfMeasureReset()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WfpManagerLandUnitsOfMeasureView);
